<div [class.mobile]="deviceService.isMobile()"
     [class.tablet]="deviceService.isTablet()"
     class="tabs-wrap">
  <ul class="tabs" itemscope itemtype="http://schema.org/SiteNavigationElement">
    <ng-template [ngForOf]="tabs" let-item ngFor>
      <li [attr.title]="item.title | customLocale" class="categories-item">
        <a (click)="setActiveTab(item)" [class.active]="activeTab === item.code"
           class="tab"
           itemprop="url">
          <span class="tab-name normal">{{ item.title | customLocale }}</span>
        </a>
      </li>
    </ng-template>
  </ul>
</div>
